import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
import { getTextColor } from '@magalu/stereo-ui-styles';
export var CountLabel = styled.p(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-right: auto;\n"])), function (props) {
  return getTextColor('light')(props);
});